import SectionHeading from '../common/SectionHeading';
import { reviews } from '../../data/siteContent';

function ReviewsSection() {
  return (
    <section className="block reviews-section" id="review">
      <div className="wrap">
        <SectionHeading eyebrow="REVIEW" title="고객님들이 남겨주신 이야기">※ 아래 후기는 이해를 돕기 위한 예시입니다.</SectionHeading>
        <div className="reviews-grid">
          {reviews.map(({ initial, name, detail, body }) => (
            <article className="review-card reveal" key={name}>
              <div className="stars" aria-label="별점 5점">★★★★★</div>
              <p>“{body}”</p>
              <div className="reviewer"><span className="avatar">{initial}</span><div><b>{name}</b><span>{detail}</span></div></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ReviewsSection;
